import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  required,
  usePermissions,
  Identifier,
  RaRecord,
  minLength,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router";

import EmailInput from "../common/EmailInput";
import { SYSTEM_ADMINISTRATOR } from "../authProvider/roles";
import { validateEmailAddress } from "./validators";
import useUpdateWithValidation from "../common/useUpdateWithValidation";
import { PasswordInput } from "../common/PasswordInput";
import FormContainer from "../common/FormContainer";

const MailAccountEdit = () => {
  const { permissions } = usePermissions();
  const location = useLocation();
  const { returnTo } = parse(location.search);

  const fromDomain = (
    _resource?: string,
    _id?: Identifier,
    data?: Partial<RaRecord>
  ) => `Domain/${data?.domainId}/show/mail-accounts`;

  const save = useUpdateWithValidation("MailAccount", {
    redirectTo: returnTo === "MailAccountFromDomains" ? fromDomain : "list",
  });

  return (
    <Edit>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput
              optionText="name"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="domainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput
                  optionText="unicodeName"
                  fullWidth
                  validate={required()}
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <EmailInput
            source="emailAddress"
            validate={validateEmailAddress}
            fullWidth
          />
          <TextInput
            source="username"
            validate={required()}
            disabled={permissions !== SYSTEM_ADMINISTRATOR}
            fullWidth
          />
          <PasswordInput
            source="password"
            helperText="Leer lassen, um bestehendes Passwort zu verwenden."
            validate={[minLength(8)]}
            fullWidth
          />
        </FormContainer>
      </SimpleForm>
    </Edit>
  );
};
export default MailAccountEdit;
